<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.formules.title' | translate"
  [description]="'organizer.edit.formules.description' | translate"
  [isFormValid]="isFormValid"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateFormule()"
>
  <app-form-input-group
    [label]="'organizer.edit.formules.title.label' | translate"
    [errors]="title?.touched && title?.errors"
    errorKey="title"
    class="block mb-4"
  >
    <app-form-input
      #content
      [formControl]="title"
      [placeholder]="'organizer.edit.formules.title.placeholder' | translate"
    ></app-form-input>
  </app-form-input-group>

  <app-form-input-group
    [label]="'organizer.edit.formules.price.label' | translate"
    [errors]="price?.touched && price?.errors"
    errorKey="price"
    class="block mb-4"
  >
    <app-form-input
      #content
      [formControl]="price"
      [placeholder]="'organizer.edit.formules.price.placeholder' | translate"
    ></app-form-input>
  </app-form-input-group>

  <app-form-input-group
    [label]="'organizer.edit.formules.description.label' | translate"
    [errors]="description?.touched && description?.errors"
    errorKey="description"
    class="block mb-4"
  >
    <app-form-textarea
      #content
      [formControl]="description"
      [placeholder]="
        'organizer.edit.formules.description.placeholder' | translate
      "
      [rows]="5"
      [maxLength]="defaultMaximumCharacters"
    ></app-form-textarea>
  </app-form-input-group>

  <app-divider [class.hidden]="!isTabletDevice"></app-divider>

  <div right-column #rightColumn [class.right-column-desktop]="!isTabletDevice">
    <div
      *ngFor="let sport of sports; let index = index"
      class="grid grid-cols-12 mb-6"
    >
      <div class="col-span-12 mb-2">Offre N° {{ index + 1 }}</div>
      <app-form-input-group
        [label]="'organizer.edit.formules.sport.title' | translate"
        [errors]="sportTitle[index]?.touched && sportTitle[index]?.errors"
        errorKey="sportTitle"
        class="col-span-12 lg:col-span-10 mb-4"
      >
        <app-form-input
          #content
          class="block"
          [formControl]="sportTitle[index]"
          placeholder=""
        ></app-form-input>
      </app-form-input-group>

      <app-form-image
        #controlChild
        [formControl]="photo[index]"
        class="flex h-activity-creation-photo col-span-12 lg:col-span-10 mb-4"
        (change)="checkFormValidity(index)"
      ></app-form-image>

      <app-form-input-group
        [label]="'organizer.edit.formules.sport.description' | translate"
        [errors]="
          sportDescription[index]?.touched && sportDescription[index]?.errors
        "
        errorKey="sportDescription"
        class="col-span-12 lg:col-span-10"
      >
        <app-form-textarea
          #content
          [formControl]="sportDescription[index]"
          [placeholder]="
            'organizer.edit.formules.price.placeholder' | translate
          "
          [rows]="5"
          [maxLength]="defaultMaximumCharacters"
        ></app-form-textarea>
      </app-form-input-group>
    </div>
  </div>
</app-organizer-shared-layout-edit-field>
